import { Bell, CaretUpDown } from "@phosphor-icons/react";
import { Link, NavLink, useParams } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import WorkspaceImage from "common/components/WorkspaceImage";
import useWorkspaces from "common/datahooks/useWorkspaces";
import type { NavItemType } from "common/types";

import MobileNav from "./MobileNav";

function MobileHeader({ navItems }: { navItems: NavItemType[] }) {
  const { workspaceId } = useParams();
  const { workspaces } = useWorkspaces();

  const { name, accounts_count: accountsCount } =
    workspaces.find(({ id }) => id === workspaceId) ?? {};

  return (
    <div className="sticky top-0 z-nav flex h-20 w-full items-center justify-between gap-3 bg-white p-4 shadow-sm">
      <Link
        to="/workspaces"
        className="flex flex-1 items-center gap-x-2 rounded-3xl border border-black-200 px-3 py-2 transition-colors"
        state={{ canGoBack: true }}
      >
        <WorkspaceImage id={workspaceId} />
        <div className="flex flex-col gap-y-1">
          <span className="line-clamp-1 break-all text-left text-md-bold">
            {name}
          </span>
          <span className="text-xs-medium text-black-500">
            {accountsCount
              ? `${accountsCount} account${accountsCount > 1 ? "s" : ""}`
              : "No accounts"}
          </span>
        </div>
        <CaretUpDown size={20} className="ml-auto" />
      </Link>

      <Button intent="iconOnly" variant="ghost-black" size="lg">
        <NavLink to="notifications">
          <Bell weight="fill" />
        </NavLink>
      </Button>
      <MobileNav navItems={navItems} />
    </div>
  );
}

export default MobileHeader;
